import { ISettingsService } from "../typings/typings";

export class LegacyUrlService {
    public static $inject = ["SettingsService"];
    constructor(private SettingsService: ISettingsService) {}

    public getPathFromLegacyPath(legacyPath: string) {
        const prefix = this.SettingsService.legacy_content.prefix;
        const pattern = new RegExp("^(/)?(" + prefix + ")(.*)");

        return legacyPath.replace(pattern, "$1$3");
    }
}
